import careconnect from "../assets/images/careconnect.png";
import femguard from "../assets/images/femguard.png";
import harvesthub from "../assets/images/harvesthub.png";
import steershield from "../assets/images/steershield.png";
import equistox from "../assets/images/equistox.png";
import attendease from "../assets/images/attendease.png";
export const project_list = [
  {
    id: 1,
    image: careconnect,
    name: "Care-Connect",
    description:
      "An AI-Powered Post-Discharge Care with computer vision physio assistance, AR/VR rehab, and an AI-assistant for healthcare and medical support. It includes medicine reminders, a Care Ring for SOS alerts, and seamless patient-doctor-hospital connectivity.",
    ghlink: "https://github.com/harish201105/Care-Connect",
    demolink: "https://youtube.com/@harishparthasarathy2005?si=dfVLmt5wyccPQ6aO",
  },
  {
    id: 2,
    image: femguard,
    name: "Fem-Guard",
    description:
      "An Intelligent and Secured mobile app designed to enhance women’s safety. It features a blockchain-powered complaint portal, safe zone-based travel recommendations, live tracking with an emergency alert system using a smart ring, and a conversational chatbot for mental support during distress.",
    ghlink: "https://github.com/harish201105/FemGuard",
    demolink: "https://youtube.com/@harishparthasarathy2005?si=dfVLmt5wyccPQ6aO",
  },
  {
    id: 3,
    image: attendease,
    name: "Attend-Ease",
    description:
      "Cloud based attendance tracking platform with advanced computer vision technology, ensuring seamless and accurate student attendance through facial recognition.",
    ghlink: "https://github.com/harish201105/visionary_attendence_management_system",
    demolink: "https://youtube.com/@harishparthasarathy2005?si=dfVLmt5wyccPQ6aO",
  },
  {
    id: 4,
    image: harvesthub,
    name: "Harvest-Hub",
    description:
      "An Agriculture Management System designed to streamline and optimize various farming processes. An Interface for farmers and landowners to manage their farms, crops, machinery, and more.",
    ghlink: "https://github.com/harish201105/Harvest-Hub",
    demolink: "https://youtube.com/@harishparthasarathy2005?si=dfVLmt5wyccPQ6aO",
  },
  {
    id: 5,
    image: steershield,
    name: "Steer-Shield",
    description:
      "A Road safety vehicle detection system which enhances bike driver’s safety by identifying helmet and enforcing compliance through automatic number plate recognition and penalty registration using CNN.",
    ghlink: "https://github.com/harish201105/Helmet-and-Number-Plate-Detection-and-Recognition",
    demolink: "https://youtube.com/@harishparthasarathy2005?si=dfVLmt5wyccPQ6aO",
  },
  {
    id: 6,
    image: equistox,
    name: "Equi-Stox",
    description:
      "A stock market prediction system that utilizes advanced machine learning techniques to analyze historical data and predict future stock prices, empowering investors with valuable insights for informed decision-making.",
    ghlink: "https://github.com/harish201105/Stock-Market-Management-App",
    demolink: "https://youtube.com/@harishparthasarathy2005?si=dfVLmt5wyccPQ6aO",
  },
];
